import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'caseOutContrastController';
export default {
    /**
     * 下载对账单模板
     */
    downLoadBill: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'downLoadBill',
        type: requestType.Get
    },
    /**
     * 下载还款记录模板
     */
    downLoadRepaymentRecord: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'downLoadRepaymentRecord',
        type: requestType.Get
    }
};
